import { render, staticRenderFns } from "./display-comment.vue?vue&type=template&id=ec27121a&scoped=true&"
import script from "./display-comment.vue?vue&type=script&lang=js&"
export * from "./display-comment.vue?vue&type=script&lang=js&"
import style0 from "./display-comment.vue?vue&type=style&index=0&id=ec27121a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec27121a",
  null
  
)

export default component.exports